import PageContainer from 'layouts/PageContainer'
import FeedingAnalyticsCard from './FeedingAnalyticsCard'
import { SummaryReport } from './summary-report/SummaryReport'

const AnalyticsPage = () => {
	return (
		<PageContainer>
			<SummaryReport />
			<FeedingAnalyticsCard />
		</PageContainer>
	)
}

export default AnalyticsPage
